export function redirectToHubDomain() {
  if (window.location.hostname === "co2.enit.io") {
    window.location.replace("https://hub.enit.io/app/carbon");
  }
}
